import cartAPI from '../../_api/cart';
import { SET_CART_OFFERS, CHECK_ALL_CART_OFFERS,
  CHECK_CART_OFFER, DELETE_CART_OFFERS,
  SET_CART_COUPON, REMOVE_CART_COUPON
} from '../constants/cart';
import { incrementCartCount } from './auth';

export const setCartOffers = (list) => ({ type: SET_CART_OFFERS, list });
export const checkCartOffer = id => ({ type: CHECK_CART_OFFER, id });
const removeCartOffers = ids => ({ type: DELETE_CART_OFFERS, ids });
export const checkAllCartOffers = is_checked => ({ type: CHECK_ALL_CART_OFFERS, is_checked });

export const setCoupon = (coupon) => ({ type: SET_CART_COUPON, coupon });
export const removeCartCoupon = () => ({ type: REMOVE_CART_COUPON });

export const getCartOffers = () => async (dispatch) => {
  const response = await cartAPI.getOffers();
  if (response) {
    const offers = response.map(o => o.offer);
    dispatch(setCartOffers(offers));
    return response;
  }
};

export const deleteCartOffers = (ids) => async (dispatch) => {
  const response = await cartAPI.deleteCartOffers(ids);
  if (response) dispatch(removeCartOffers(ids));
};

export const setCartCoupon = (coupon) => async (dispatch) => {
  dispatch(setCoupon(coupon));
};

export const deleteCartCoupon = (coupon) => async (dispatch) => {
  dispatch(removeCartCoupon(coupon));
};

export const buyCartOffers = (payload) => async (dispatch) => {
  // console.log(payload);
  try{
    let response = await cartAPI.buyCartOffers(payload);
    if (response){
      document.location = response.redirect_url;
    }
  } catch (e) {
  }
};

export const createPayment = (id) => async (dispatch) => {
  try{
    let response = await cartAPI.createPayment(id);
    if (response){
      return response;
    }
  } catch (e) {
  }
};
